import types from "./types"

export const open = ({ componentName, componentProps }) => ({
  type: types.OPEN,
  payload: { componentName, componentProps },
})

export const close = () => ({ type: types.CLOSE })
